<script>
import formatDate from '@utils/format-date'
import { messageSuccess } from "@utils/message"
import formMixin from "@components/Form/mixins/form";
import { authComputed } from '@store/helpers'
import { taiwanCitys, districtsFilter, findDistrictZip } from '@utils/address'

const DEFAULT_SUBMIT_DATA = {
  city: "",
  district: "",
  address: "",
};

export default {
  page() {
    return {
      title: `會員中心 | 地址簿`,
    }
  },
  components: {
    MemberLayout: () => import("./components/Layout.Jtails"),
  },
  mixins: [formMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return { ...DEFAULT_SUBMIT_DATA }
      },
    },
    type: {
      type: String,
      default: 'add',
      validator(value) {
        return [
          'add',
          'edit',
        ].includes(value)
      },
    },
    memberInfo: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      taiwanCitys,
      errorMessage: '',
    }
  },
  computed: {
    ...authComputed,
    /* serviceDistricts() {
      return districtsFilter(this.FormMixSubmitData.city)
    }, */
    shippingDistricts() {
      return districtsFilter(this.FormMixSubmitData.city)
    },
    formattedSubmitData() {
      const { shippingInfoBook: { shipping }, ...restData } = this.memberInfo
      const postcode = findDistrictZip(this.FormMixSubmitData.city, this.FormMixSubmitData.district)
      return {
        ...restData,
        shippingInfoBook: {
          shipping: {
            ...shipping,
            postcode,
            ...this.FormMixSubmitData,
          }
        }
      }
    }
  },
  created() {
    const initFormMixSubmitData = () => {
      const { shippingInfoBook: { shipping } } = this.memberInfo
      this.FormMixSubmitData.city = shipping.city 
      this.FormMixSubmitData.district = shipping.district
      this.FormMixSubmitData.address = shipping.address
    };

    initFormMixSubmitData();
    this.$FormMixinInitTempSubmitData();
  },
  methods: {
    formatDate,
    onCancel() {
      this.$emit('cancel')
    },
    onSubmit() {
      this.tryToStoreInfo();
    },
    onChangeCity() {
      this.FormMixSubmitData.district = '';
    },
    tryToStoreInfo() {
      this.$store.dispatch('wordpress/storeMember', {
        ...this.formattedSubmitData
      })
        .then(() => {
          messageSuccess('已儲存');
          this.$FormMixinOnSubmitSuccess();
          this.$FormMixinInitTempSubmitData();
        })
    },
  }
}
</script>
<!-- section template -->
<template>
  <MemberLayout
    :class="$style.viewMemberInfo"
    title="運送地址"
    type="list"
  >
    <ValidationObserver v-slot="{ invalid, handleSubmit }">
      <el-form
        ref="form"
        :model="FormMixSubmitData"
        label-position="top"
        class="isStyleBase"
        :class="$style.formInfo"
        @submit.prevent.native="handleSubmit(onSubmit)"
      >
        <div class="mb-5">
          <el-row :gutter="20">
            <el-col :span="12">
              <ValidationProvider
                v-slot="{ errors }"
                name="縣市"
                rules="require"
              >
                <el-form-item :error="errors[0]" prop="city" label="選擇縣市" class="isRequired">
                  <el-select
                    v-model="FormMixSubmitData.city"
                    placeholder="請選擇縣市"
                    clearable
                    @change="onChangeCity"
                  >
                    <el-option v-for="(city, index) in taiwanCitys" :key="`city-${index}`" :label="city.name" :value="city.name"> </el-option>
                  </el-select>
                </el-form-item>
              </ValidationProvider>
            </el-col>
            <el-col :span="12">
              <ValidationProvider
                v-slot="{ errors }"
                name="區域"
                rules="require"
              >
                <el-form-item :error="errors[0]" prop="district" label="選擇區域" class="isRequired">
                  <el-select
                    v-model="FormMixSubmitData.district"
                    placeholder="請選擇區域"
                    clearable
                  >
                    <el-option v-for="(district, index) in shippingDistricts" :key="`district-${index}`" :label="district.name" :value="district.name"> </el-option>
                  </el-select>
                </el-form-item>
              </ValidationProvider>
            </el-col>
          </el-row>
          <ValidationProvider
            v-slot="{ errors }"
            name="詳細地址"
            rules="require"
          >
            <el-form-item :error="errors[0]" prop="address" label="詳細地址" class="isRequired">
              <el-input
                v-model="FormMixSubmitData.address"
              >
              </el-input>
            </el-form-item>
          </ValidationProvider>
        </div>
        
        <!-- <hr>

        <div class="mb-5 pt-4">
          <div class="layout__header">
            <h2 class="layout__title">
              服務地址
            </h2>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <ValidationProvider
                v-slot="{ errors }"
                name="縣市"
                rules="require"
              >
                <el-form-item :error="errors[0]" prop="shippingInfo.0.city" label="選擇縣市" class="isRequired">
                  <el-select
                    v-model="FormMixSubmitData.shippingInfo[0].city"
                    placeholder="請選擇縣市"
                    clearable
                    @change="onChangeCity"
                  >
                    <el-option v-for="(city, index) in taiwanCitys" :key="`city-${index}`" :label="city.name" :value="city.name"> </el-option>
                  </el-select>
                </el-form-item>
              </ValidationProvider>
            </el-col>
            <el-col :span="12">
              <ValidationProvider
                v-slot="{ errors }"
                name="區域"
                rules="require"
              >
                <el-form-item :error="errors[0]" prop="shippingInfo.0.district" label="選擇區域" class="isRequired">
                  <el-select
                    v-model="FormMixSubmitData.shippingInfo[0].district"
                    placeholder="請選擇區域"
                    clearable
                  >
                    <el-option v-for="(district, index) in shippingDistricts" :key="`district-${index}`" :label="district.name" :value="district.name"> </el-option>
                  </el-select>
                </el-form-item>
              </ValidationProvider>
            </el-col>
          </el-row>
          <ValidationProvider
            v-slot="{ errors }"
            name="詳細地址"
            rules="require"
          >
            <el-form-item :error="errors[0]" prop="shippingInfo.0.address" label="詳細地址" class="isRequired">
              <el-input
                v-model="FormMixSubmitData.shippingInfo[0].address"
              >
              </el-input>
            </el-form-item>
          </ValidationProvider>
        </div> -->
        <div class="row pt-4">
          <div class="col-md-6">
            <BaseButton
              class="isStylePrimary isOutline3 isFull isRadius mb-3 mb-md-0"
              @click="$FormMixinOnResetSubmitData"
            >
              取消
            </BaseButton>
          </div>
          <div class="col-md-6">
            <BaseButton
              :disabled="invalid"
              :loading="$isLoading('storeMember')"
              class="isStyleSecondary isFull isRadius"
              type="submit"
            >
              儲存修改
            </BaseButton>
          </div>
        </div>
      </el-form>
      <BasePre>formattedSubmitData: {{ formattedSubmitData }}</BasePre>
      <BasePre>FormMixSubmitData: {{ FormMixSubmitData }}</BasePre>
    </ValidationObserver>
  </MemberLayout>
</template>
<!-- section style -->
<style lang="scss" module>
.formInfo {
  :global {
    .formInfo {
      @include unstyled;
    }
  }
}
</style>
